import { INetworkClient } from "@/domain/repositories/NetworkClient";
import { IRoutesCertificateGetAllCertificates } from "@/types/src/backend/routes/certificate/getAllCertificates";
import { IRoutesUserCertificateListUserCertificates } from "@/types/src/backend/routes/userCertificate/listUserCertificates";

export class CertificateUseCase {
  constructor(private readonly networkClient: INetworkClient) {}

  async getCertificates(
    token: string,
    companyId: string
  ): Promise<
    IRoutesCertificateGetAllCertificates["outputData"]["certificates"]
  > {
    const response = await this.networkClient.get(`/certificates/${companyId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.error) {
      throw new Error(response.error);
    }

    return response.data.certificates;
  }

  async getUserCertificates(
    userId: string,
    token: string
  ): Promise<
    IRoutesUserCertificateListUserCertificates["outputData"]["userCertificates"]
  > {
    const response = await this.networkClient.get(
      `/userCertificates/user/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.error) {
      throw new Error(response.error);
    }

    return response.data.userCertificates;
  }

  async deleteCertificate(certificateId: string, token: string) {
    const response = await this.networkClient.delete(
      `/userCertificates/${certificateId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.error) {
      throw new Error(response.error);
    }
  }

  async uploadCertificate(
    userCertificate: {
      user: string;
      certificate: string;
      file?: File;
      financedByPrime?: boolean;
    },
    token: string
  ) {
    const certificateFormData = new FormData();
    certificateFormData.append("user", userCertificate.user);
    certificateFormData.append("certificate", userCertificate.certificate);
    certificateFormData.append(
      "financedByPrime",
      userCertificate.financedByPrime ? "true" : "false"
    );
    userCertificate.file &&
      certificateFormData.append("file", userCertificate.file);

    const response = await this.networkClient.post(
      `/userCertificates`,
      certificateFormData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.error) {
      throw new Error(response.error);
    }
  }
}
